import { IncreaseCreditLimit as AuIncreaseCreditLimit } from "components/IncreaseCreditLimit/IncreaseCreditLimit";
import { State } from "components/IncreaseCreditLimit/types";
import { Account } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { useAccountInfo } from "library/hooks/useAccountInfo";
import { useConfigFeature } from "library/hooks/useConfig";
import { NzIncreaseCreditLimit } from "./NzIncreaseCreditLimit";

type Props = {
  location: {
    state?: {
      account: Account;
      product: Product;
    };
  };
  initialState: State;
};

export const IncreaseCreditLimit = (props: Props) => {
  const accountInfo = useAccountInfo(props.location.state?.account);
  const useCliPageUrl = useConfigFeature("useCliPageUrl");

  const Component =
    accountInfo?.isNZ && useCliPageUrl
      ? NzIncreaseCreditLimit
      : AuIncreaseCreditLimit;

  return <Component {...props} />;
};
